// Krishna DP — uses the local optimized Krishna portrait inside an elegant
// gold-ringed circle. Small (~10 KB webp) with PNG fallback for older browsers.

export default function KrishnaAvatar({ size = 40, className = "" }) {
  const s = size;
  return (
    <div
      className={
        "relative shrink-0 rounded-full overflow-hidden " +
        "shadow-[0_6px_20px_-6px_rgba(197,160,89,0.7)] " +
        className
      }
      style={{
        width: s,
        height: s,
        background:
          "radial-gradient(circle at 30% 20%, #FFFDF6 0%, #FFF7E4 55%, #F6E7BE 100%)",
        border: "1.5px solid #DFB96E",
      }}
      aria-hidden
    >
      <picture>
        <source srcSet="/krishna-dp-256.webp" type="image/webp" />
        <img
          src="/krishna-dp.png"
          alt=""
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
      </picture>
      {/* Subtle inner gold hairline for polish */}
      <span
        aria-hidden
        className="absolute inset-[2px] rounded-full pointer-events-none"
        style={{ boxShadow: "inset 0 0 0 0.5px rgba(255, 247, 228, 0.6)" }}
      />
    </div>
  );
}
